import React from 'react';
import Form from 'react-forms-system';

import Button from '@material-ui/core/Button';

import Modal from '@/components/Modal';
import SearchFieldControl from '@/components/SearchFieldControl';
import TextInputControl from '@/components/TextInputControl';

import { required } from '@/core/validators';

const OrganizationModal = ({ controller, onClose, organization }) => (
  <Modal visible onClose={onClose} className="OrganizationModal">
    <Modal.Header onClose={onClose} />
    <Form onStateChange={controller.handleFormChange} onSubmit={controller.handleSubmit}>
      <div className="content form">
        <div className="group">
          <div className="control">
            <Form.Control
              name="name"
              label="Organization Name"
              variant="outlined"
              value={controller.formState?.values.name}
              component={TextInputControl}
              errorMessages={{ required: 'Required' }}
              validators={{ required }}
            />
          </div>
        </div>

        <div className="group">
          <div className="control">
            <Form.Control
              name="affiliate"
              label="Code"
              variant="outlined"
              value={controller.formState?.values.affiliate}
              component={SearchFieldControl}
              getOptions={controller.handleGetAffiliates}
              getOptionLabel={controller.handleGetAffiliateLabel}
              getOptionSelected={controller.handleGetAffiliateValue}
              defaultValue={null}
              errorMessages={{ required: 'Required' }}
              validators={{ required }}
            />
          </div>

          <div className="control">
            <Form.Control
              name="user"
              label="User"
              variant="outlined"
              value={controller.formState?.values.user}
              component={SearchFieldControl}
              getOptions={controller.handleGetUsers}
              getOptionLabel={controller.handleGetUserLabel}
              getOptionSelected={controller.handleGetUserSelected}
              defaultValue={null}
              errorMessages={{ required: 'Required' }}
              validators={{ required }}
            />
          </div>
        </div>

        <div className="group">
          <Button type="submit" color="primary" variant="contained">
            {`${organization?.id ? 'Update' : 'Create'} Organization`}
          </Button>
        </div>
      </div>
    </Form>
  </Modal>
);

export default OrganizationModal;
